import { toggleAddon, getPlans, updateAddonMeta } from '@/System/Store/Api/ApiDepartments';
import { getAddons } from '@/System/Store/Api/ApiPayment';
import { setSnackbar } from '@/helpers';

const initialState = () => ({
    addons: [],
    plans: [],
});

const state = initialState();

const mutations = {
    SET_ADDONS: (state, array) => (state.addons = array),
    SET_PLANS: (state, array) => (state.plans = array),
    RESET_STATE: (state) => Object.assign(state, initialState()),
};

const actions = {
    async GET_ADDONS({ commit }) {
        await getAddons().then((response) => {
            if (response.status === 'Success') {
                commit('SET_ADDONS', response.data);
            }
        });
    },
    async GET_PLANS({ commit }) {
        await getPlans().then((response) => {
            if (response.status === 'Success') {
                commit('SET_PLANS', response.data);
            }
        });
    },
    ACTIVATE_ADDON({ commit, dispatch }, payload) {
        toggleAddon(payload).then((response) => {
            const snackbar = setSnackbar(response);

            if (response.status === 'Success') {
                commit('SET_ADDONS', response.data);

                // Refresh the user and department data
                dispatch('UserStore/GET_ME', null, { root: true });
            }

            commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
        });
    },
    DEACTIVATE_ADDON({ commit, dispatch }, payload) {
        payload.method = 'revoke';
        toggleAddon(payload).then((response) => {
            const snackbar = setSnackbar(response);

            if (response.status === 'Success') {
                // Refresh the user and department data
                dispatch('UserStore/GET_ME', null, { root: true });
            }

            commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
        });
    },
    UPDATE_ADDON_META({ commit }, payload) {
        updateAddonMeta(payload).then((response) => {
            const snackbar = setSnackbar(response);

            if (response.status === 'Success') {
                commit('SET_ADDONS', response.data);
            }

            commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
        });
    },
};

const getters = {
    GET_ADDONS: (state) => state.addons,
    GET_PLANS: (state) => state.plans,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
